module.exports = __webpack_public_path__ + "fonts/iconfont.dd5bb35.woff";